<app-icon *ngIf="item.icon"
  class="img item-icon" [src]="item.icon"
  [opacity]="(item.unlocked || highlight) ? undefined : 0.5"
  [draggable]="false"
  (click)="iconClick($event)">
</app-icon>
<span class="emote-level" *ngIf="item.type === ItemType.Emote">Lv{{item.level}}</span>
<app-item-icons *ngIf="showSubIcons" [item]="item"></app-item-icons>
